// Google Analytics 4 Event Tracking Utilities

/**
 * Track hero video completion (사용자가 끝까지 시청)
 */
export const trackHeroVideoComplete = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'hero_video_complete', {
      event_category: 'engagement',
      video_title: 'logl_intro'
    });
  }
};

/**
 * Track hero CTA click (히어로 섹션 주요 버튼 클릭)
 * @param {string} ctaType - 'scroll_down', 'learn_more', 'get_started' 등
 */
export const trackHeroCTAClick = (ctaType) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'hero_cta_click', {
      event_category: 'engagement',
      cta_type: ctaType
    });
  }
};

/**
 * Track interactive demo menu click
 * @param {string} menuName - Menu name: 'home', 'mingl', 'connect', 'talk', 'passport'
 */
export const trackDemoMenuClick = (menuName) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'demo_menu_click', {
      event_category: 'engagement',
      menu_name: menuName
    });
  }
};

/**
 * Track YouTube language video click
 * @param {string} language - Language code: 'ko', 'en', 'ja'
 */
export const trackYouTubeLanguageClick = (language) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'youtube_language_click', {
      event_category: 'engagement',
      language: language
    });
  }
};

/**
 * Track scroll depth
 * @param {number} percentage - Scroll percentage: 25, 50, 75, 100
 */
export const trackScrollDepth = (percentage) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', `scroll_${percentage}`, {
      event_category: 'engagement',
      scroll_depth: percentage
    });
  }
};

/**
 * Track waitlist email submission
 */
export const trackWaitlistSubmit = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'generate_lead', {
      event_category: 'conversion',
      event_label: 'Waitlist Signup'
    });
  }
};

/**
 * Track section view
 * @param {string} sectionName - Section name
 */
export const trackSectionView = (sectionName) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'section_view', {
      event_category: 'engagement',
      section_name: sectionName
    });
  }
};

/**
 * Track external click conversion (외부 클릭 전환)
 */
export const trackExternalClickConversion = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'conversion', {
      'send_to': 'AW-17705827994/FQPRCJS4g70bEJr95fpB'
    });
  }
};
